import React from 'react'
import Button from '@amzn/meridian/button'
import Row from '@amzn/meridian/row'
import { IClearFilterButtonProps } from '../types'
import { CLEAR_FILTER } from '../constants'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'

/**
 * ClearFilterButton Component
 *
 * A right-aligned text button displayed below the StoreFilterSelect when a store filter is active.
 * Hidden when no filter is active (visible prop is false).
 */
export const ClearFilterButton: React.FC<IClearFilterButtonProps> = ({ visible, onClear }) => {
    const [bundle] = useBundle(BUNDLE_NAME)

    if (!visible) {
        return null
    }

    return (
        <Row widths={['fill', 'fit']} width="100%">
            <span />
            <Button
                type="link"
                onClick={onClear}
                data-testid="clear-filter-button"
            >
                {t(bundle, CLEAR_FILTER)}
            </Button>
        </Row>
    )
}
